import React from 'react';

export const Gravatar = ({user = {}, className}) => {
  const { displayName, gravatarUrl } = user || {};
  if(!user || !gravatarUrl || !displayName) {
    return <img className={className} src="/assets/img/avatar.png" alt="nobody" />
  }
  return <img className={className} src={gravatarUrl + '?d=mm'} alt={displayName} />
};
